import { useEffect } from 'react'
import { Trans } from 'react-i18next'

import { Modal } from '@makyoapp/makyo-ui'

import { useGridImportData } from '@/hooks/useGridImportData'
import { IMPORT_STEPS } from '@/utils/grid-import'

import GridImportPreviewData from './components/GridImportPreviewData'
import GridImportProcessData from './components/GridImportProcessData'
import GridImportSelectFile from './components/GridImportSelectFile'

const ModalStepMap = {
  [IMPORT_STEPS.SELECT_FILE]: GridImportSelectFile,
  [IMPORT_STEPS.PREVIEW_DATA]: GridImportPreviewData,
  [IMPORT_STEPS.PROCESS_DATA]: GridImportProcessData,
}

/**
 * Get the modal title based on the import type and file type
 */
function renderModalTitle(type?: 'import' | 'append', fileType?: 'excel' | 'csv' | null) {
  if (!type || !fileType) return ''

  if (type === 'append') {
    return fileType === 'excel' ? 'Import Excel to Append to Existing Table' : 'Import CSV to Append to Existing Table'
  }

  return fileType === 'excel' ? 'Import Excel to Create New Table' : 'Import CSV to Create New Table'
}

/**
 * GridImportModal Component
 *
 * This component serves as the main container for the data import process.
 * It manages the display of different modal steps based on the current import state.
 */
export default function GridImportModal() {
  // Use the custom hook to access import state and functions
  const { resetImport, importState } = useGridImportData()

  const ActiveModalStep =
    importState.step && importState.step in ModalStepMap
      ? ModalStepMap[importState.step as keyof typeof ModalStepMap]
      : null

  useEffect(() => {
    if (!importState.step) {
      resetImport()
    }
  }, [importState.step, resetImport])

  return (
    <Modal show={!!importState.step} closeOnClickOutside={false}>
      <Modal.Header onCloseClick={resetImport}>
        <Trans>{renderModalTitle(importState.type, importState.fileType)}</Trans>
      </Modal.Header>

      {ActiveModalStep && <ActiveModalStep />}
    </Modal>
  )
}
